module.exports = __webpack_public_path__ + "media/images/frontend/download_covid19_file-4b0a35f5f3eb66163d293f639fb7930d.svg";